import React from 'react';

import styled from 'styled-components';
import LogoCsCat from './../../img/logoGobierno.png';

//Condiciones del curso en el formulario principal 
const CondicionesCurso = () => {
    return (
        <>
            <Contenedor>
                <Img src={LogoCsCat} />
                <p>*En el caso de los desempleados, deben estar inscritos como demandantes 
                    de empleo en el servicio público de empleo de su comunidad autónoma para 
                    poder participar.</p>
                <p>La superación del curso supone la obtención de un diploma acreditativo que 
                    incluye el logotipo del Ministerio de Trabajo y Economía Social del Gobierno de España.
                </p>
                <p>“Los cursos pertenecen a la Resolución de 6 de agosto de 2024, 
                    del Servicio Público de Empleo Estatal, por la que se aprueba la convocatoria para la 
                    concesión, de subvenciones públicas para la ejecución de programas de formación de ámbito 
                    estatal, dirigidos prioritariamente a las personas ocupadas.”</p>
            </Contenedor>

        </>
    );
}

const Contenedor = styled.div`
    text-align: center;
    padding-left: 25%;
    padding-right: 25%;
    margin-top: 2%;
    padding-bottom: 7%;
    p{
        color: #7A7A7A;
        font-family: 'Roboto';
    }

    @media screen and (max-width: 768px) {
        padding-left: 10%;
        padding-right: 10%;
    }

`;

const Img = styled.img`
    margin-top: 5%;
    margin-bottom: 5%;
    width:300px;

    @media screen and (max-width: 768px) {
        width:315px;
        
    }

`;



export default CondicionesCurso;